import { Navigate, useLocation } from 'react-router-dom'
import { authClient } from '../lib/auth-client'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const { data: session, isPending } = authClient.useSession()
  
  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" aria-live="polite">
        <div className="animate-pulse text-muted-foreground">Loading…</div>
      </div>
    )
  }
  
  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  
  return <>{children}</>
}
